import { RESTClient } from './client';
import { API_URL } from './apiDictionary';
import axios, { AxiosRequestConfig } from 'axios';
import {
  FetchExternalUserReportListResponse,
  ExternalUserFileToUpload,
  UploadExternalUserReportResponse,
  DownloadExternalUserReportsResponse,
} from '@restore/ExternalUserReports/ExternalUserReports.types';
import { prepareUrl } from '@utils/routerHelpers';

interface UploadOptions extends AxiosRequestConfig {
  signal?: AbortSignal;
}

export const setUploadFile = async (
  file: File,
  uploadUrl: string,
  options: UploadOptions = {}
) => {

  const response = await axios.request({
    method: 'PUT',
    url: uploadUrl,
    data: file,
    headers: {
      'Content-Type': 'application/octet-stream',
    },
    ...options,
  });

  return { code: response.status };
};

type ConfirmationExternalUserReportArgs = {
  clinicalTrialId: string,
  patientId: string,
  visitId: string,
  fileIds: string[],
};

export const confirmationExternalUserReport = async ({
  clinicalTrialId,
  patientId,
  visitId,
  fileIds,
}: ConfirmationExternalUserReportArgs) => {
  const url = prepareUrl(API_URL.externalUserUploadReportConfirm, [patientId, visitId]);
  const response = await RESTClient.put<[]>(url, { fileIds }, {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
  });

  return response.data;
};

type UploadExternalUserReportArgs = {
  files: ExternalUserFileToUpload[],
  siteId: string,
  clinicalTrialId: string,
  patientId: string,
  visitId: string
};

export const uploadExternalUserReport = async ({
  files,
  siteId,
  clinicalTrialId,
  patientId,
  visitId,
}: UploadExternalUserReportArgs) => {
  const url = prepareUrl(API_URL.externalUserUploadReport, [patientId, visitId]);
  const response = await RESTClient.post<UploadExternalUserReportResponse>(url, { files }, {
    headers: {
      'x-dynamika-site-id': siteId,
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
  });

  return response.data;
};

export const fetchExternalUserReportList = async (
  clinicalTrialId: string,
  patientId: string
) => {
  const url = prepareUrl(API_URL.externalUserReportList, [patientId]);
  const response = await RESTClient.get<FetchExternalUserReportListResponse>(url, {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
  });

  return response.data;
};

export const downloadExternalUserFiles = async (
  clinicalTrialId: string,
  fileIds: string[]
) => {
  const url = prepareUrl(API_URL.externalUserReportsDownload, []);
  const response = await RESTClient.post<DownloadExternalUserReportsResponse>(
    url,
    {fileIds},
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
    }
  );

  return response.data;
};
